import React from 'react';

import './agent-login-prompt.scss';
import { AgentLoginPromptProps } from './types';
import { EVENT_NAMES, emit } from 'root/widgets/events';

const AgentLoginPrompt: React.FC<AgentLoginPromptProps> = ({ label, link, metadata, context }) => {
  const handleLinkClick = () => {
    emit(EVENT_NAMES.PG_LOGIN.AGENT_LOGIN_PROMPT, context);
  };

  return (
    <div className="agent-login-prompt-root" {...metadata}>
      <div className="label">{label}</div>
      <a href={link.href} da-id="login-agentnet-lnk" onClick={handleLinkClick}>
        {link.title}
      </a>
    </div>
  );
};

AgentLoginPrompt.displayName = 'AgentLoginPrompt';

export default AgentLoginPrompt;
